<template>
  <div>
    <div class="title">
      <Row :gutter="10">
        <!-- <Col span="4" style="padding-left: 10px">
          <Select
            v-model="accountType"
            filterable
            :placeholder="
              $t('permission_configuration_management.group.checkByAccountType')
            "
            @on-change="searchAccountType()"
            :transfer="true"
          >
            <Option value="" selected>{{
              $t("permission_configuration_management.common.all")
            }}</Option>
            <Option
              :value="item.id"
              v-for="item in accountTypeList"
              :key="item.name"
              >{{ item.name }}</Option
            >
          </Select>
        </Col> -->
        <Col span="4">
          <Input
            search
            v-model="accountName"
            :placeholder="
              $t('permission_configuration_management.group.checkByAccountName')
            "
            @on-search="searchAccountName()"
          />
        </Col>
        <Col span="4">
          <Input
            search
            v-model="cacheClusterId"
            :placeholder="$t('permission_configuration_management.resourcePermission.searchByCacheClusterId')"
            @on-search="searchCacheClusterId()"
          />
        </Col>
        <Col span="4">
          <Button type="primary" @click="handleShowAdd">{{ $t('permission_configuration_management.resourcePermission.addRedis') }}</Button>
        </Col>
      </Row>
    </div>
    <Modal
      v-model="modal"
      :title="$t('permission_configuration_management.resourcePermission.addRedis')"
      width="900px;"
      :loading="modalLoading"
      :ok-text="$t('alarms.common.add')"
      :mask-closable="false"
      :closable="false"
    >
      <Form
        :model="resourceForm"
        :label-width="100"
        ref="resourceForm"
        :rules="ruleValidate"
      >
        <!-- 搜索 -->
        <Row :gutter="16">
          <!-- 云平台 -->
          <!-- <Col span="7">
            <FormItem
              :label="
                $t('permission_configuration_management.group.cloudPlatform')
              "
              prop="accountTypeSearchKey"
              :label-width="60"
            >
              <Select
                v-model="resourceForm.accountTypeSearchKey"
                filterable
                @on-change="
                  changeAccountTypeSearchKey(resourceForm.accountTypeSearchKey)
                "
                :transfer="true"
                placeholder=""
              >
                <Option
                  :value="item.id"
                  v-for="item in accountTypeList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col> -->
          <Col span="7">
            <!-- 账户 -->
            <FormItem
              :label="$t('permission_configuration_management.group.account')"
              prop="account"
              :label-width="50"
            >
              <Select
                v-model="resourceForm.account"
                @on-change="changeAccount(resourceForm.account)"
                multiple
                :max-tag-count="1"
                :transfer="true"
                :placeholder="
                  $t('permission_configuration_management.common.pleaseSelect')
                "
              >
                <Checkbox
                  v-model="singleAccount"
                  @on-change="selectAccountAll"
                  style="display: block; text-align: right"
                  >{{ $t("alarms.common.allSelected") }}</Checkbox
                >
                <Option
                  :value="item.id"
                  @click.native="getMoreParams(item)"
                  v-for="(item, index) in accountList"
                  v-bind:key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col
            span="7"
            style="z-index: 200"
          >
            <!-- 存储区域 -->
            <FormItem
              :label="$t('permission_configuration_management.group.region')"
              prop="region"
              :label-width="50"
            >
              <Select
                @on-change="changeRegion(resourceForm.region)"
                v-model="resourceForm.region"
                :transfer="true"
                :placeholder="
                  $t('permission_configuration_management.common.pleaseSelect')
                "
              >
                <Option
                  :value="item.name"
                  v-for="item in regionList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Button
            type="primary"
            style="float: right"
            @click="searchElastiCacheInput()"
            >{{ $t("alarms.common.search") }}</Button
          >
        </Row>
      </Form>
      <div slot="footer">
        <Button @click="cancel('resourceForm')">{{
          $t("permission_configuration_management.common.cancel")
        }}</Button>
        <Button
          type="primary"
          @click="handleSubmit('resourceForm')"
          :loading="addloading"
          :disabled="isDisable"
          >{{
            $t("permission_configuration_management.common.confirm")
          }}</Button
        >
      </div>
      <Table
        :no-data-text="$t('common.noData')"
        ref="selection"
        :columns="columns"
        :loading="loading"
        :data="queryAccountElastiCacheData"
        :height="400"
        @on-selection-change="getSelection"
      ></Table>
    </Modal>
    <table-elasti-cache
      ref="tableElastiCacheChild"
      :getAccountType="getAccountType"
    ></table-elasti-cache>
  </div>
</template>

<script>
import { getCookie } from "../../../../utils/cookieUtil.js";
import TableElastiCache from "../resource_permission/TableElastiCache";

const tableElastiCache = TableElastiCache;
export default {
  name: "AddElastiCache",
  components: {
    TableElastiCache
  },
  props: ["getAccountType"],
  data() {
    return {
      platformType: "",
      accountType: "",
      accountName: "",
      cacheClusterId: "",
      selection: [],
      accountTypeList: [],
      modal: false,
      modalLoading: true,
      loading: false,
      addloading: false,
      isDisable: true,
      accountList: [],
      regionList: [],
      singleAccount: false,
      resourceForm: {
        accountTypeSearchKey: null,
        account: [],
        region: ""
      },
      ruleValidate: {
        accountTypeSearchKey: [
          {
            required: true,
            message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectCloudPlatform"),
            trigger: "change",
            type: "number"
          }
        ],
        account: [
          {
            required: true,
            message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectAccountName"),
            trigger: "change",
            type: "array"
          }
        ],
        region: [
          { required: true, message: this.$t("permission_configuration_management.resourcePermission.pleaseSelectStorageRegion"), trigger: "change" }
        ]
      },
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("permission_configuration_management.resourcePermission.nodeName"),
          key: "cacheClusterId"
        },
        {
          title: this.$t("permission_configuration_management.resourcePermission.cacheEngine"),
          key: "cacheEngineName"
        },
        {
          title: this.$t("permission_configuration_management.resourcePermission.nodeType"),
          key: "cacheNodeType"
        },
        {
          title: this.$t("permission_configuration_management.group.status"),
          key: "cacheClusterStatusName"
        },
        {
          title: this.$t("permission_configuration_management.group.region"),
          key: "region"
        }
      ],
      queryAccountElastiCacheData: [],
      newQueryAccountElastiCacheDataList: []
    };
  },
  methods: {
    // 按账户类型筛选
    searchAccountType: function() {
      eventBus.$emit("accountType", this.accountType);
      tableElastiCache.methods.showAll();
    },
    // 按账户名称筛选
    searchAccountName: function() {
      eventBus.$emit("accountName", this.accountName);
      tableElastiCache.methods.showAll();
    },
    // 按网关ID搜索
    searchCacheClusterId: function() {
      eventBus.$emit("cacheClusterId", this.cacheClusterId);
      tableElastiCache.methods.showAll();
    },
    // 父组件调用子组件table内的方法
    pagingQuery() {
      this.$refs.tableElastiCacheChild.pagingQuery();
    },
    // 云平台
    queryCloudPlatforms: function() {
      this.$api.account
        .queryCloudPlatforms("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountTypeList = res.data;
        });
    },
    // 切换云平台
    changeAccountTypeSearchKey: function() {
      this.resourceForm.account = [];
      this.accountList = [];
      this.regionList = [];
      this.resourceForm.region = "";
    },
    handleShowAdd() {
      this.modal = true; // 清空表格
      this.singleAccount = false;
      this.queryAccountElastiCacheData = [];
      this.selectAccountByCloudPlatform();
    },
    //查询账号
    selectAccountByCloudPlatform: function() {
      this.$api.groupAccountRelation
        .getAccountByGroupIdAndCloudPlatform({
          groupId: this.$route.query.id,
          accountType: this.getAccountType
        })
        .then(res => {
          this.accountList = res.data;
        });
    },
    selectAccountAll() {
      this.resourceForm.account = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.resourceForm.account.push(item.id);
        });
      } else {
        this.resourceForm.account = [];
      }
    },
    // 切换账户
    changeAccount: function(val) {
      if (this.resourceForm.account.length == 0) {
        return;
      }
      // 清空表格
      this.queryAccountElastiCacheData = [];
      this.resourceForm.region = "";
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      this.$api.account
        .queryAccountRegionsByAccountIds(
          "accountIds",
          this.resourceForm.account
        )
        .then(res => {
          this.regionList = res.data;
        });
    },
    //获取自己要的属性
    getMoreParams: function(params) {
      //账号类型
      this.platformType = params.type;
    },
    // 切换存储区域
    changeRegion: function() {
      this.queryAccountElastiCacheData = [];
    },
    // 当前选择checkbox
    getSelection: function(selection) {
      this.newQueryAccountElastiCacheDataList = selection;
      // 选了数据 可以点击下一步
      if (this.newQueryAccountElastiCacheDataList.length == 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    // 点击查询
    searchElastiCacheInput: function() {
      this.loading = true;
      // 根据AccountId查询列表
      if(this.resourceForm.account.length==0){
        this.$Message.error(this.$t('permission_configuration_management.resourcePermission.pleaseSelectAccountName'));
        return;
      }
      if(!this.resourceForm.region){
        this.$Message.error(this.$t('RAM.common.PleaseSelectRegion'));
        return;
      }
      if (
        this.getAccountType == 0 ||
        this.getAccountType == 1 ||
        this.getAccountType == 2 ||
        this.getAccountType == 3
      ) {
        this.$api.awsCache
          .listResourceAliRedisDTOByAliApi({
            region: this.resourceForm.region,
            accountIds: this.resourceForm.account,
            groupId: this.$route.query.id
          })
          .then(res => {
            this.queryAccountElastiCacheData = res.data;
            this.loading = false;
          });
      } else if (this.getAccountType == 4) {
        this.$api.awsCache
          .listResourceGcpRedisDTOByAliApi({
            region: this.resourceForm.region,
            accountIds: this.resourceForm.account,
            groupId: this.$route.query.id
          })
          .then(res => {
            this.queryAccountElastiCacheData = res.data;
            this.loading = false;
          });
      } else if (this.getAccountType == 6) {
        this.$api.awsCache
          .listResourceTencentRedisDTOByTencentApi({
            accountIds: this.resourceForm.account,
            region: this.resourceForm.region,
            groupId: this.$route.query.id
          })
          .then(res => {
            this.queryAccountElastiCacheData = res.data;
            this.loading = false;
          });
      }
    },
    // 添加
    handleSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 增加
          this.addloading = true;
          this.$api.adminGroupResourceAwsCacheRelationship
            .create({
              groupId: this.$route.query.id,
              resourceAwsCacheDTOs: this.newQueryAccountElastiCacheDataList,
              accountType: this.getAccountType
            })
            .then(res => {
              setTimeout(() => {
                tableElastiCache.methods.showAll();
                this.$refs[name].resetFields();
                this.modalLoading = false;
                this.$nextTick(() => {
                  this.modalLoading = true;
                });
                this.$Message.success(this.$t("common.addSuccess"));
                this.queryAccountElastiCacheData = [];
                this.newQueryAccountElastiCacheDataList = [];
                this.modal = false;
                this.addloading = false;
                this.isDisable = true;
                this.singleAccount = false;
                this.accountList = [];
                this.regionList = [];
              }, 1000);
            })
            .catch(() => {
              this.addloading = false;
              this.$Message.error(this.$t("common.addFail"));
            });
        } else {
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 0);
          this.$Message.error(this.$t("common.addFail"));
        }
      });
    },
    // 取消
    cancel: function(name) {
      this.isDisable = true;
      this.modal = false;
      this.singleAccount = false;
      this.accountList = [];
      this.regionList = [];
      this.queryAccountElastiCacheData = [];
      this.newQueryAccountElastiCacheDataList = [];
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.title {
  width: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/AddElastiCache.vue